import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Col, Container, Row } from "reactstrap";
import { Navigation, Autoplay } from "swiper";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import { compose } from "redux";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";

import useWindowSize from "components/shared/WindowResize";
import * as gameAction from "redux/game/action";
import * as socketAction from "redux/sockets/action";

const HeroSec = ({ heroParams, ...props }) => {
  const { width } = useWindowSize();

  const onStartActivity = async (game_code) => {
    props.setIsLoading(true);
    let gameCodee = game_code;
    var cognitoUser = await Auth.userPool.getCurrentUser();
    if (cognitoUser !== null) {
      if (width < 768) {
        props.setGameName(gameCodee);
        props.history.push("/launch_controller");
      } else {
        if (gameCodee === "GAHW") {
          localStorage.setItem("work_game", gameCodee);
          props.setGameName("GAH");
        } else if (gameCodee === "GAHF") {
          localStorage.setItem("work_game", gameCodee);
          props.setGameName("GAH");
        } else if (gameCodee === "CHPTW") {
          localStorage.setItem("work_game", gameCodee);
          props.setGameName("CHPT");
        } else {
          props.setGameName(gameCodee);
          localStorage.removeItem("work_game");
        }
        props.history.push("/lobby");
      }
    } else {
      props.setIsLoading(false);
      sessionStorage.setItem("gameCode", gameCodee);
      props.setGameName(gameCodee);
      props.history.push("/signup");
    }
  };
  return (
    <>
      <section className="hero-slider">
        <Container>
          <Row>
            <Col xs={12} sm={12}>
              <Swiper
                navigation={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false
                }}
                modules={[Navigation, Autoplay]}
                className="mySwiper"
              >
                {heroParams?.map((activity, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div className="hero-section">
                        <div className="hero-img-wrap">
                          <img
                            src={activity?.graphic}
                            className="hero-img"
                            alt=""
                          />
                        </div>
                        <div className="hero-content">
                          <h5 className="hero-subtitle">
                            {activity?.top_label}
                          </h5>
                          <h3 className="hero-title">{activity?.title}</h3>
                          <button
                            onClick={() => {
                              activity.game_code
                                ? onStartActivity(activity?.game_code)
                                : (window.location.href = activity.link_url);
                            }}
                            className="btn hero-btn"
                          >
                            {activity?.button}
                          </button>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    endGame: (data) => dispatch(gameAction.endGame(data)),
    setGameName: (data) => dispatch(gameAction.setGameName(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(HeroSec);
